import React from 'react';

export type InputProps = { icon?: React.ReactNode; inputClassName?: string } & React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className = '', inputClassName = '', icon, ...rest }, ref) => {
    return (
        <div className={'h-[34px] flex items-center rounded-[4px] bg-midnight text-ash-grey px-[8px] ' + className}>
            {icon && <div className='shrink-0'>{icon}</div>}
            <span className={`h-full min-w-0 w-full bg-transparent ${rest['readOnly'] ? 'hidden' : ''}`}>
                <input ref={ref} className={'shrink-1 h-full min-w-0 w-full bg-transparent ' + inputClassName} type='text' {...rest} />
            </span>
            {rest['readOnly'] && <span className={inputClassName}>{rest['value']}</span>}
        </div>
    );
});

Input.displayName = 'Input';
